import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CardsSection from '@/pages/home/components/CardsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <ContactSection />
        <CommentsSection />
        <FaqSection />
        <FeaturesSection />
        <IndexSection />
        <MediaSection />
        <TopicsSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}